import { useState } from 'react'
import { Upload } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { UploadWizard } from '@/components/ged/UploadWizard'
import { useUser } from '@/contexts/UserContext'
import { Permissions } from '@/lib/permissions'

type Props = {
  areaId: string
  areaName: string
}

export function UploadTriggerButton({ areaId, areaName }: Props) {
  const { hasPermission } = useUser()
  const [open, setOpen] = useState(false)

  // Toda área aceita arquivo direto (spec 2026-09-13) — a permissão de edição é o
  // único gate.
  if (!hasPermission(Permissions.DocumentManagementEdit)) return null

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>
          <Upload size={14} style={{ marginRight: 6 }} /> Enviar arquivos
        </Button>
      </DialogTrigger>
      {/* 95% da viewport em largura e altura, igual ao visualizador de PDF.
          O `sm:max-w-4xl` anterior foi REMOVIDO em vez de sobrescrito: o
          tailwind-merge trata classes com variante responsiva como chave
          própria, então um `max-w-none` sem variante não venceria dele a
          partir de 640px. O tamanho vai em estilo inline, que não depende
          dessa resolução. */}
      <DialogContent
        className="max-w-none"
        style={{ width: '95vw', height: '95vh', display: 'flex', flexDirection: 'column' }}
      >
        <DialogHeader style={{ flexShrink: 0 }}>
          <DialogTitle>Enviar arquivos — {areaName}</DialogTitle>
        </DialogHeader>
        {/* minHeight: 0 é o que permite o filho flex encolher e rolar sozinho,
            em vez de esticar o diálogo além dos 95vh. */}
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
          <UploadWizard initialAreaId={areaId} onClose={() => setOpen(false)} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
